import {
  IonCardHeader,
  IonGrid,
  IonRow,
  IonCol,
  IonCardTitle,
  IonCardSubtitle,
  IonButtons,
  IonButton,
  IonIcon,
} from '@ionic/react';
import { informationCircleOutline } from 'ionicons/icons';

import styles from '@/components/SectionHeader/cardHeader.module.css';

import { mergeClassNames } from '@/utils/mergeClassNames';

import ORYX_MagnifyingGlassIcon from '@/assets/icons/ORYX_MagnifyingGlassIcon.svg';

interface ORYXCardHeaderProps {
  title?: string;
  subtitle?: string;
  info?: boolean;
  zoom?: boolean;
  setShowInfo?: React.Dispatch<
    React.SetStateAction<{
      show: boolean;
    }>
  >;
  setShowZoom?: React.Dispatch<
    React.SetStateAction<{
      show: boolean;
    }>
  >;
  children?: React.ReactNode;
}

export const ORYXCardHeader = ({
  title,
  subtitle,
  info,
  setShowInfo,
  zoom,
  setShowZoom,
  children,
}: ORYXCardHeaderProps) => {
  return (
    <IonCardHeader className={styles.cardHeader}>
      <IonGrid className='ion-no-padding' fixed>
        <IonRow className={mergeClassNames('ion-align-items-center', styles['header'])}>
          <IonCol className={styles['content']} size='9'>
            <IonCardTitle className={styles.title}>{title}</IonCardTitle>
            {subtitle && <IonCardSubtitle className={styles.subTitle}>{subtitle}</IonCardSubtitle>}
          </IonCol>

          <IonCol className='ion-justify-content-center ion-text-end' size='3'>
            {zoom ||
              (info && (
                <IonButtons className='ion-justify-content-end'>
                  {zoom && setShowZoom && (
                    <IonButton
                      className='attractorCard_Header_Buttons'
                      fill='clear'
                      onClick={() => setShowZoom({ show: true })}
                      slot='icon-only'>
                      <IonIcon icon={ORYX_MagnifyingGlassIcon} />
                    </IonButton>
                  )}
                  {info && setShowInfo && (
                    <IonButton
                      className='attractorCard_Header_Buttons'
                      fill='clear'
                      onClick={() => setShowInfo({ show: true })}
                      slot='icon-only'>
                      <IonIcon icon={informationCircleOutline} />
                    </IonButton>
                  )}
                </IonButtons>
              ))}
            {children}
          </IonCol>
        </IonRow>
      </IonGrid>
    </IonCardHeader>
  );
};
